import { ApplySupplierCertificatePermission } from ".";
import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Row, Col } from "reactstrap";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import {
  TextFieldHookForm, SearchableSelectHookForm
} from "./../../layout/HookFormInputs";
// import { PaginationWrapper } from "../../../common/commonPagination";
import { reactLocalStorage } from "reactjs-localstorage";
import _ from "lodash";
// import { resetStatePagination } from "../../../common/Pagination/paginationAction";
import ReactExport from "react-export-excel";
import LoaderCustom from "../../common/LoaderCustom";
import NoContentFound from "../../common/NoContentFound";
import { resetStatePagination } from "../../common/Pagination/paginationAction";
import PopupMsgWrapper from "../../common/PopupMsgWrapper";
import Toaster from "../../common/Toaster";
import { PaginationWrapper } from "../../common/commonPagination";
import { setSelectedRowForPagination } from "../../simulation/actions/Simulation";
import {
  activeInactiveSpecializationList,
  deleteSpecialization,
  fetchAllSpecialization,
} from "../SpecializationList/Actions";
import AddSpecializationList from "../SpecializationList/addSpecializationList/AddSpecializationList";
import {
  EMPTY_DATA,
  PaymentList,
  SpeciaList,
  defaultPageSize,
} from "../../../config/constants";
import {
  PAYMENT_LIST_EXCEL,
  SPECILIZATION_LIST_EXCEL,
} from "../../../config/masterData";
import { useForm, Controller } from "react-hook-form";
import { MESSAGES } from "../../../config/message";
import {
  handleDepartmentHeader,
  loggedInUserId,
  searchNocontentFilter,
  setLoremIpsum,
  showTitleForActiveToggle,
  userDetails,
} from "../../../helper";
import {
  activeInactivePaymentMasterList,
  addNewPaymentMaster,
  fetchAllPaymentMaster,
  getPaymentMasterDetailById,
  getAllDepartmentMaster,
  getSupplierCategoryById,
  saveSupplierCategory,
  fetchAllCategoryMaster
} from "./Action";
import AddSupplierCategory from "./Component/AddSupplierCategory";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const SupplierCerificateMasterList = (props) => {
  const permissionSpecialization = useContext(ApplySupplierCertificatePermission);
  const { PaymentMasterReducer } = useSelector(
    (state) => state?.PaymentMasterReducer
  );

  // const [loading, setLoading] = useState(false);
  const datata = useSelector((state) => state);

  const dispatch = useDispatch();
  //////////////
  // const { control, handleSubmit, setValue, errors } = useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [isModalRejectOpen, setIsModalRejectOpen] = useState(false);
  /////////////
  // const [isModalRejectOpen, setIsModalRejectOpen] = useState(false);
  // const [showPopup, setShowPopup] = useState(false);
  const [deletedId, setDeletedID] = useState(null);
  const [loader, setloader] = useState(false);
  const [open, setOpen] = useState(false);
  const [certificateTypeID, setCertificateTypeID] = useState("");
  const [supplierCategoryId, setSupplierCategoryId] = useState("");
  const [categorytypeID, setCategorytypeID] = useState("00000000-0000-0000-0000-000000000000");
  const [isEnabled, setIsEnabled] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [pageSize, setPageSize] = useState({
    pageSize10: true,
    pageSize50: false,
    pageSize100: false,
  });

  const currentListQty = (PaymentMasterReducer?.page - 1) * 10;
  let serialNumber = currentListQty + 1; // Start numbering from 1
  // const usersWithSerialNumbers = PaymentMasterReducer?.Data;
  const usersWithSerialNumbers = (PaymentMasterReducer?.Data || []).map(
    (user, index) => {
      const updatedSerialNumber = serialNumber + index;
      return {
        ...user,
        serialNumber: updatedSerialNumber,
      };
    }
  );
  const [requestTypeList, setrequestTypeList] = useState([]);
  const {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { isSubmitting, isSubmitted, isValid, errors },
  } = useForm({ defaultValues: { IsActive: true }, mode: "onChange" });
  const [state, setState] = useState({
    isEditFlag: false,
    isOpenVendor: false,
    shown: false,
    ID: "",
    tableData: [],
    city: [],
    country: [],
    state: [],
    showPopup: false,
    deletedId: "",
    cellData: {},
    cellValue: "",
    showPopupToggle: false,
    isViewMode: false,
    isLoader: false,
    selectedRowData: false,
    noData: false,
    dataCount: 0,
    type: "",
    render: false,
    showExtraData: false,
  });

  const getUsers = async (categorytypeID) => {
    try {
      // Set loader to true to indicate data fetching
      setloader(true);
      // Dispatch the action to fetch users
      await dispatch(
        fetchAllCategoryMaster({
          CertificateTypeID: categorytypeID,
          // current_page: currentPage,
          // per_page: pageSize,
          // sortOrder: sortOrder,
          // sortField: fieldName,
        })
      );
      // Reset loader to false after the data is fetched
      setloader(false);
    } catch (error) {
      // Handle errors, e.g., display an error message

      // Reset loader to false in case of an error
      setloader(false);
    }
  };
  /**
   * @method onFloatingFilterChanged
   * @description Filter data when user type in searching input
   */
  const onFloatingFilterChanged = (value) => {
    setTimeout(() => {
      if (usersWithSerialNumbers.length !== 0) {
        setState((prevState) => ({
          ...prevState,
          noData: searchNocontentFilter(value, prevState.noData),
        }));
      }
    }, 500);
  };
  useEffect(() => {
    getAllRequestType();
    if (categorytypeID) {
      setLoading(true);
      getSupplierCategoryById(categorytypeID)
        .then((response) => {


          if (response?.data?.Data) {
            const specializationData = response.data.Data;

            setData(specializationData);
          } else {

          }
        })
        .catch((error) => {

        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      reset();
    }
  }, [categorytypeID, reset]);


  // useEffect(() => {
  //   // Function to fetch data after a 3-second delay
  //   const fetchDataWithDelay = async () => {
  //     // Show loader
  //     setloader(true);

  //     // Simulate loading for 3 seconds
  //     await new Promise((resolve) => setTimeout(resolve, 500));

  //     try {
  //       // Fetch data after the delay
  //       await getUsers(categorytypeID, 1, defaultPageSize, "ASC");
  //     } catch (error) {
  //       
  //     } finally {
  //       // Hide loader after fetching data or encountering an error
  //       setloader(false);
  //     }
  //   };
  //   // Call fetchDataWithDelay function
  //   fetchDataWithDelay();
  // }, [categorytypeID]);

  const getAllRequestType = (props) => {
    setLoading(true); // Set loading to true during data fetching
    getAllDepartmentMaster()
      .then((res) => {
        setrequestTypeList(res?.Data); // Update state with response data


      })
      .catch(() => { })
      .finally(() => setLoading(false)); // Set loading to false after data fetching
  };

  useEffect(() => {
    reactLocalStorage.setObject("selectedRow", {});
    if (!props.stopApiCallOnCancel) {
      return () => {
        dispatch(setSelectedRowForPagination([]));
        dispatch(resetStatePagination());

        reactLocalStorage.setObject("selectedRow", {});
      };
    }
  }, []);
  const gridOptions = {};
  const onRowSelect = () => {
    const selectedRows = state.gridApi?.getSelectedRows();
    setState((prevState) => ({
      ...prevState,
      selectedRowData: selectedRows,
      dataCount: selectedRows.length,
    }));
  };
  // const onBtExport = () => {
  //   let tempArr = state.gridApi && state.gridApi.getSelectedRows();
  //   tempArr =
  //     tempArr && tempArr.length > 0
  //       ? tempArr
  //       : usersWithSerialNumbers
  //         ? usersWithSerialNumbers
  //         : [];
  //   return returnExcelColumn(PAYMENT_LIST_EXCEL, tempArr);
  // };

  // const returnExcelColumn = (data = [], TempData) => {
  //   return (
  //     <ExcelSheet data={TempData} name={PaymentList}>
  //       {data &&
  //         data.map((ele, index) => (
  //           <ExcelColumn
  //             key={index}
  //             label={
  //               ele.label === "Company Name"
  //                 ? `${handleDepartmentHeader()} Name`
  //                 : ele.label
  //             }
  //             value={ele.value}
  //             style={ele.style}
  //           />
  //         ))}
  //     </ExcelSheet>
  //   );
  // };
  const isFirstColumn = (params) => {
    var displayedColumns = params.columnApi.getAllDisplayedColumns();
    var thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const defaultColDef = {
    resizable: true,
    filter: true,
    sortable: false,
    headerCheckboxSelectionFilteredOnly: true,
    checkboxSelection: isFirstColumn,
  };
  const onGridReady = (params) => {
    window.screen.width >= 1300 && params.api.sizeColumnsToFit();
    setState((prevState) => ({
      ...prevState,
      gridApi: params.api,
      gridColumnApi: params.columnApi,
    }));
    params.api.paginationGoToPage(0);
    setState((prevState) => ({ ...prevState, gridApi: params.api }));
  };
  const onPageSizeChanged = (newPageSize) => {
    state.gridApi.paginationSetPageSize(Number(newPageSize));
  };

  const buttonFormatter = (props) => {
    props.api.sizeColumnsToFit();
    const handleEdit = () => {
      const requestId = props.data?.PaymentTermId;
      // Handle edit action
      // history.push(`/add-business-type?id=${requestId}&mode=edit`);
      setOpen({ open: true, id: requestId });
    };

    const handleDeletePopup = () => {
      setShowPopup(true);
      setDeletedID(props?.data?.PaymentTermId);
    };
    return (
      <div>
        {permissionSpecialization?.Edit && (
          <button
            title="Edit"
            className="Edit hl-accept-icon mr-2"
            type="button"
            onClick={handleEdit}
          ></button>
        )}
        {permissionSpecialization?.Delete && (
          <button
            title="Delete"
            className="Delete hl-delete-icon"
            type="button"
            onClick={handleDeletePopup}
          ></button>
        )}
      </div>
    );
  };
  const statusButtonFormatter = (props) => {
    const cellValue = props?.valueFormatted
      ? props?.valueFormatted // Fix: Change 'valueFormatted' to 'valueFormatted'
      : props?.value;
    const rowData = props?.valueFormatted
      ? props?.valueFormatted // Fix: Change 'valueFormatted' to 'valueFormatted'
      : props?.data;
    showTitleForActiveToggle(props?.rowIndex, "Active", "Inactive");
    return (
      <>
        <label
          htmlFor="normal-switch"
          className="normal-switch Tour_List_Status"
        >
          <Switch
            onChange={() => handleChange(cellValue, rowData)}
            checked={cellValue}
            background="#ff6600"
            onColor="#4DC771"
            onHandleColor="#ffffff"
            offColor="#FC5774"
            id="normal-switch"
            height={24}
            className={cellValue ? "active-switch" : "inactive-switch"}
          />
        </label>
      </>
    );
  };

  const handleChange = (cell, row) => {

    let data = {
      Id: row.PaymentTermId,
      ModifiedBy: loggedInUserId(),
      IsActive: !cell, //Status of the user.
    };
    setState((prevState) => ({
      ...prevState,
      showPopupToggle: true,
      cellData: data,
      cellValue: cell,
    }));
  };

  const CheckboxCellRenderer = (props) => {

    const [isChecked, setIsChecked] = useState(props.value);
    setSupplierCategoryId(props.data.CertificateTypeID);
    setCertificateTypeID(props.data.CertificateTypeID);
    setIsEnabled(props.data.IsEnabled);

    const toggleCheckbox = () => {
      const newValue = !isChecked;
      setIsChecked(newValue);

      // Optionally, notify the grid about the value change
      if (props.node) {
        props.node.setDataValue(props.colDef.field, newValue);
      }
    };

    return (
      <input
        type="checkbox"
        checked={isChecked}
        onChange={toggleCheckbox}
      />
    );
  };

  const frameworkComponents = {
    totalValueRenderer: buttonFormatter,
    statusButtonFormatter: statusButtonFormatter,
    customNoRowsOverlay: NoContentFound,
    checkboxCellRenderer: CheckboxCellRenderer,
  };




  const onRejectConfirm = () => {
    setIsModalRejectOpen(false);
  };


  const handleSelectChange = (selectedOption) => {
    // Log the selected option object
    const selectedDepartmentId = selectedOption ? selectedOption.value : '';

    setCategorytypeID(selectedDepartmentId);
  };

  const closePopUp = () => {
    setShowPopup(false);
    setState((prevState) => ({ ...prevState, showPopupToggle: false }));
  };
  const renderListing = (label) => {

    if (label === "requestTypeListData") {
      return requestTypeList.map((requestTypeListing) => ({
        value: requestTypeListing.DepartmentId,
        label: requestTypeListing.DepartmentName,
      }));
    }
  };
  const onSubmit = (formData) => {
    // Start loading
    setLoading(true);

    // Get employee ID
    const empId = userDetails();

    // Map the data with the form data
    const newData = data.map((item) => ({
      SupplierCertificateMappingId: item.SupplierCertificateMappingId,
      CertificateTypeID: item.CertificateTypeID,
      SupplierCategoryId: formData.Categories.value,
      CertificateTypeName: item.CertificateTypeName,
      IsEnabled: item.IsEnabled,
      ModifiedOn: item.ModifiedOn,
      CreatedOn: item.CreatedOn,
      CreatedBy: empId?.EmployeeId,
      UpdatedBy: empId?.EmployeeId,
    }));

    // Dispatch action to save supplier category
    dispatch(
      saveSupplierCategory(newData, (res) => {
        // Stop loading
        setLoading(false);

        // Reset form
        // reset();

        // Handle response
        if (res?.IsSuccessful) {
          setValue("Categories", "");
          Toaster.success(res?.Data?.Message);
          // props.setOpen(false);
          getUsers(categorytypeID);
        } else {
          Toaster.error(res?.data?.ErrorMessage || 'Form submission failed');
        }
      })
    );
  };

  const handleCheckboxChange = (id, value) => {
    const updatedData = data.map((item) =>
      item.CertificateTypeID === id
        ? { ...item, IsEnabled: value }
        : item
    );
    setData(updatedData);
  };
  const checkboxCellRenderer = (params) => {
    const { data } = params;
    return (
      <input
        type="checkbox"
        checked={data.IsEnabled || false}
        onChange={(e) =>
          handleCheckboxChange(data.CertificateTypeID, e.target.checked)
        }
      />
    );
  };
  return (
    <>
      {loading && <LoaderCustom customClass="simulation-Loader" />}
      {showPopup && (
        <PopupMsgWrapper
          isOpen={showPopup}
          closePopUp={() => setShowPopup(false)}
          // confirmPopup={onPopupConfirm}
          message="Are you sure you want to delete this item?"
        />
      )}
      {isModalRejectOpen && (
        <PopupMsgWrapper
          isOpen={isModalRejectOpen}
          closePopUp={() => setIsModalRejectOpen(false)}
          confirmPopup={onRejectConfirm}
          message="Are you sure you want to reject this application?"
        />
      )}
      <Row className="ag-grid-react without-filter-grid">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Col>
            <div>
              <div className={`ag-theme-material ${loading && 'max-loader-height'}`}>
                <Row className="filter-row-large">
                  <Col md="12" className="mb-3 d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                      <div className="warning-message d-flex text-left align-items-center">
                        <SearchableSelectHookForm
                          label="Categories"
                          name="Categories"
                          Controller={Controller}
                          rules={{
                            required: true,
                            // maxLength: 50,
                          }}
                          register={register}
                          options={renderListing('requestTypeListData')}
                          control={control}
                          placeholder="Enter"
                          customClassName="withBorder mb-0"
                          handleChange={handleSelectChange}
                          errors={errors.Categories}
                          disabled={false}
                          mandatory={true}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end bd-highlight w100"></div>
                  </Col>
                </Row>

                <div
                  className={`ag-grid-wrapper height-width-wrapper ${(data.length <= 0 || state.noData) ? 'overlay-contain' : ''
                    }`}
                >
                  <div className={`ag-theme-material ${state.isLoader && 'max-loader-height'}`}>
                    {state.noData && <NoContentFound title="No Data" customClassName="no-content-found" />}
                    {state.isLoader ? (
                      <LoaderCustom customClass="loader-center" />
                    ) : (
                      <AgGridReact
                        defaultColDef={{ sortable: true, filter: true }}
                        floatingFilter={true}
                        domLayout="autoHeight"
                        rowData={data}
                        pagination={true}
                        paginationPageSize={10}
                        onGridReady={onGridReady}
                        rowSelection="multiple"
                        suppressRowClickSelection={true}
                        onSelectionChanged={() => { }}
                        onFilterModified={() => { }}
                        width="100%"
                      >
                        <AgGridColumn
                          field="CertificateTypeName"
                          headerName="Certificate Name"
                          floatingFilter={false}
                        ></AgGridColumn>
                        <AgGridColumn
                          field="IsEnabled"
                          headerName="Status"
                          floatingFilter={false}
                          cellRendererFramework={checkboxCellRenderer}
                        ></AgGridColumn>
                      </AgGridReact>
                    )}
                    <button type="submit" className="submit-button save-btn float-right">
                      <div className="save-icon"></div> Submit
                    </button>
                    <PaginationWrapper gridApi={state.gridApi} setPage={() => { }} />
                  </div>
                </div>
              </div>

            </div>
          </Col>
        </form>
      </Row>
      {state.showPopupToggle && (
        <PopupMsgWrapper
          isOpen={state.showPopupToggle}
          closePopUp={() => setState((prevState) => ({ ...prevState, showPopupToggle: false }))}
          confirmPopup={() => { }}
          message="Are you sure you want to toggle this item?"
        />
      )}
      {/* <AddSupplierCategory closeDrawer={() => { }} setOpen={() => { }} open={false} /> */}
    </>
  );
};

export default SupplierCerificateMasterList;